<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  card: {
    type: Object,
    required: true,
  },
})

// flexform settings from CE
const settings = computed(() => props.card?.settings ?? {})

// helper: first media entry by field name
const mediaByField = (field) => {
  const list = Array.isArray(props.card?.media) ? props.card.media : []
  const key = String(field || '').toLowerCase()
  return list.find(m => (m?.field || '').toLowerCase() === key) || null
}

const imageMedia = computed(() => mediaByField('image'))
const videoMedia = computed(() => mediaByField('video'))

const hasCaption = computed(() =>
  !!imageMedia.value && !!imageMedia.value.description,
)

// outer wrapper classes
const wrapperClasses = computed(() => {
  const base = ['content-item', 'module-image']

  if (hasCaption.value) {
    base.push('-caption')
  }

  // in Fluid, hideForABTest is only used on the video variant.
  if (videoMedia.value && settings.value.hideForABTest) {
    base.push('-hide-ab-test')
  }

  if (settings.value.hideMobile) base.push('-hide-mobile')
  if (settings.value.hideTablet) base.push('-hide-tablet')
  if (settings.value.hideDesktop) base.push('-hide-desktop')

  return base.join(' ')
})
</script>

<template>
  <div
    v-if="videoMedia"
    :class="wrapperClasses"
  >
    <a
      :href="videoMedia.link || undefined"
    >
      <video playsinline muted autoplay loop>
        <source
          :src="videoMedia.url"
          type="video/mp4"
        />
      </video>
    </a>
  </div>
  <div
    v-else-if="imageMedia"
    :class="wrapperClasses"
    :id="settings.anchor || null"
  >
    <a
      :href="imageMedia.link || undefined"
    >
      <img
        :src="imageMedia.url"
        :alt="imageMedia.alt || ''"
        :title="imageMedia.title || ''"
        loading="lazy"
      />
    </a>
    <div
      v-if="imageMedia.description"
      class="image__caption"
    >
      {{ imageMedia.description }}
    </div>
  </div>
</template>
